// extracted by mini-css-extract-plugin
export default {"disclosure":"disclosure__ev9H-","popupWrapper":"popupWrapper__HwVru"};